import { render, staticRenderFns } from "./DistanceReportDetails.vue?vue&type=template&id=07a070d6&scoped=true&"
import script from "./DistanceReportDetails.vue?vue&type=script&lang=js&"
export * from "./DistanceReportDetails.vue?vue&type=script&lang=js&"
import style0 from "./DistanceReportDetails.vue?vue&type=style&index=0&id=07a070d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a070d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07a070d6')) {
      api.createRecord('07a070d6', component.options)
    } else {
      api.reload('07a070d6', component.options)
    }
    module.hot.accept("./DistanceReportDetails.vue?vue&type=template&id=07a070d6&scoped=true&", function () {
      api.rerender('07a070d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Reports/DistanceReportDetails.vue"
export default component.exports